// extracted by mini-css-extract-plugin
export default {"root":"tweet-container_root__1298e","article":"tweet-container_article__shSD+"};